import { setupFontFace } from "./fontface";

// These need to be imported in order to handle compressed font files

// With inflate loaded, woff parsing will succeed
import inflate from "./inflate";
globalThis.inflate = inflate;
console.log("globalThis.inflate", globalThis.inflate);

// With unbrotli loaded, woff2 parsing will succeed
import unbrotly from "./unbrotli";
globalThis.unbrotli = unbrotly;
console.log("globalThis.unbrotli", globalThis.unbrotli);

// Load lib-font only after unbrotli is on globalThis.
const { Font: LibFont } = require("lib-font");

export class Font extends LibFont {
  // Need to override `src=` becuase we customize setupFontFace
  set src(src) {
    this.__src = src;
    (async () => {
      if (globalThis.document && !this.options.skipStyleSheet) {
        await setupFontFace(this.name, src, this.options);
      }
      this.loadFont(src);
    })();
  }
}
